import {autocomplete} from "@algolia/autocomplete-js";
import { algoliasearch } from 'algoliasearch';
import instantsearch from "instantsearch.js";
import aa from "search-insights";
import historyRouter from "instantsearch.js/es/lib/routers/history";
import {connectVoiceSearch} from "instantsearch.js/es/connectors";
import {
  connectSearchBox,
  connectSortBy,
  connectPagination,
} from "instantsearch.js/es/connectors";
import {
  hits,
  refinementList,
  currentRefinements,
  infiniteHits,
  clearRefinements,
} from "instantsearch.js/es/widgets";

const searchClient = algoliasearch(
  "MB13IY345Y",
  "a01243196f18893f9ec14da93b8cb31a",
);

const searchBarClient = {
  ...searchClient,
  search(requests) {
    if (requests.every(({params}) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: "",
          params: "",
        })),
      });
    }
    return searchClient.search(requests);
  },
};

const INSTANT_SEARCH_INDEX_NAME = "shopify_products";
const INSTANT_SEARCH_INDEX_NAME2 = "shopify_collections";

// const collectionIndex = searchClient.initIndex(INSTANT_SEARCH_INDEX_NAME2);

function getCookie(name) {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let [k, v] = el.split("=");
    cookie[k.trim()] = v;
  });
  return cookie[name];
}

let queryID = localStorage.getItem("queryID");
let objectIDS = localStorage.getItem("objectIDS");

if ("queryID" in localStorage && "objectIDS" in localStorage) {
  let THE_IDS = objectIDS.split(",");
  if (THE_IDS.length > 20) {
    THE_IDS.length = 20;
  }
  var uniqIDS = [...new Set(THE_IDS)];
}

function trackConversion() {
  try {
    aa("convertedObjectIDsAfterSearch", {
      appId: "MB13IY345Y",
      apiKey: "5a50c24f3e92ae83f808068a942a1f3b",
      userToken: getCookie("_ALGOLIA"),
      eventName: "conversion",
      index: INSTANT_SEARCH_INDEX_NAME,
      queryID: queryID,
      objectIDs: uniqIDS,
    });
  } catch (error) {}

  try {
    localStorage.removeItem("queryID");
    localStorage.removeItem("objectIDS");
  } catch (error) {
  }
}

aa("setUserToken", getCookie("_ALGOLIA"));

if ("queryID" in localStorage && "objectIDS" in localStorage) {
  aa("init", {
    appId: "MB13IY345Y",
    apiKey: "5a50c24f3e92ae83f808068a942a1f3b",
    useCookie: true,
  });
}

// register the conversion event for when a users adds to cart
const addToCartBtn = document.querySelector(
  `.product-form__buttons button[type='submit']`,
);
if (addToCartBtn) {
  addToCartBtn.addEventListener("click", function (e) {
    trackConversion();
  });
}

const instantSearchRouter = historyRouter();

const search = instantsearch({
  searchClient: searchBarClient,
  indexName: INSTANT_SEARCH_INDEX_NAME,
  insights: true,
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const indexUiState = uiState[INSTANT_SEARCH_INDEX_NAME];
        return {
          q: indexUiState.query,
          type:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Type"],
          flavourGroup:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.FlavourGroup"],
          flavour:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Flavour"],
          brand:
            indexUiState.refinementList && indexUiState.refinementList.vendor,
          size:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Size"],
          strength:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Strength"],
          ratio:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Ratio"],
          wattage:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Wattage"],
          battery:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Battery"],
          resistance:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Resistance"],
          offers:
            indexUiState.refinementList &&
            indexUiState.refinementList["named_tags.Offer"],
        };
      },
      routeToState(routeState) {
        return {
          [INSTANT_SEARCH_INDEX_NAME]: {
            query: routeState.q,
            refinementList: {
              type: routeState.type,
              flavourGroup: routeState.flavourGroup,
              flavour: routeState.flavour,
              brand: routeState.brand,
              size: routeState.size,
              strength: routeState.strength,
              ratio: routeState.ratio,
              wattage: routeState.wattage,
              battery: routeState.battery,
              resistance: routeState.resistance,
              offers: routeState.offers,
            },
          },
        };
      },
    },
  },
  future: {
    preserveSharedStateOnUnmount: true,
  },
});

// ========================================================================================================================
// ****************************
// SEARCH CARD / UI HELPERS  **
// ****************************
// ========================================================================================================================

let s_acc = document.querySelectorAll(".refine-trigger-inner-search");
let s_macc = document.querySelectorAll(".mobile-refine-trigger-inner-search");
let s_panel = document.querySelectorAll(".refine");

s_acc.forEach((i) => {
  i.addEventListener("click", () => {
    let setClasses = !i.classList.contains("active");
    setClass(s_acc, "active", "remove");
    setClass(s_panel, "show", "remove");

    if (setClasses) {
      i.classList.toggle("active");
      let ref = i.nextElementSibling;
      ref?.classList.toggle("show");
    }
  });
});

const setClass = (els, className, fnName) => {
  for (let i = 0; i < els.length; i++) {
    els[i].classList[fnName](className);
  }
};

const selectors = {
  body: document.querySelector("body"),
  mobileMenuToggle: document.querySelector("#mobile-menu-toggle-inner-search"),
  menuClose: document.querySelector("#menu-close-inncer-search"),
  menuApply: document.querySelector("#mobile-apply-inner-search"),
  mobileFilterMenu: document.querySelector(".mobile-filter-menu-inner-search"),
  mobileFilterBackdrop: document.querySelector(
    ".mobile-filter-backdrop-inner-search",
  ),
};

if (selectors.mobileMenuToggle !== null) {
  selectors.mobileMenuToggle.addEventListener("click", () => {
    // document.location.href = '#top';
    if (selectors.body) {
      selectors.body.classList.add("blocked");
    }

    if (selectors.mobileFilterMenu) {
      selectors.mobileFilterMenu.classList.toggle("active");
    }

    if (selectors.mobileFilterBackdrop) {
      selectors.mobileFilterBackdrop.classList.toggle("active");
    }

    if (document.querySelector("#searchHitsContainer")) {
      document.querySelector("#searchHitsContainer").classList.add("blocked");
    }
  });
}

if (selectors.mobileMenuToggle !== null) {
  selectors.menuClose.addEventListener("click", () => {
    // document.location.href = '#mobile-sorter';
    selectors.body.classList.remove("blocked");
    selectors.mobileFilterMenu.classList.remove("active");
    selectors.mobileFilterBackdrop.classList.remove("active");
    if (document.querySelector("#searchHitsContainer")) {
      document
        .querySelector("#searchHitsContainer")
        .classList.remove("blocked");
    }
  });
}

if (selectors.menuApply !== null) {
  selectors.menuApply.addEventListener("click", () => {
    // document.location.href = '#mobile-sorter';
    selectors.body.classList.remove("blocked");
    selectors.mobileFilterMenu.classList.remove("active");
    selectors.mobileFilterBackdrop.classList.remove("active");
    if (document.querySelector("#searchHitsContainer")) {
      document
        .querySelector("#searchHitsContainer")
        .classList.remove("blocked");
    }
  });
}

const determineProductCard = (data, sendEvent) => {
  let productURL = `/products/${data.handle}`;

  const hasMultiBuy = () => {
    let all = data.tags.toString();

    if (isOutOfStockHelper()) {
      return "";
    } else {
      if (
        (all && all.includes("Item_pro_Buy")) ||
        all.includes("Item_pro1_Buy")
      ) {
        return `<div class="card-product-slim__badge card-product-slim__multiOffer multi-buy">Multi Buy</div>`;
      } else {
        return ``;
      }
    }
  };

  const isBundle = () => {
    let all = data.tags.toString();
    if (all.includes("Bundle")) {
      return `<div class="card-product-slim__badge card-product-slim__multiOffer bundle-offer">Bundle Offer</div>`;
    } else {
      return ``;
    }
  };

  const isFree = () => {
    let all = data.tags.toString();
    if (all.includes("Free IVG")) {
      return `<div class="card-product-slim__badge card-product-slim__multiOffer free-ivg">Free IVG E-Liquid</div>`;
    } else {
      return ``;
    }
  };

  const isBundleWeek = () => {
    let all = data.tags.toString();
    if (all.includes("BundleWeek")) {
      return `<div class="card-product-slim__badge card-product-slim__multiOffer bundle-of-week">Bundle of the Week</div>`;
    } else {
      return ``;
    }
  };

  const isQuitKit = () => {
    let all = data.tags.toString();
    if (all.includes("Quit Kit")) {
      return `<div class="card-product-slim__badge card-product-slim__multiOffer quit-kit">Quit Kit of the Week</div>`;
    } else {
      return ``;
    }
  };

  const isNew = () => {
    let all = data.collections.toString();
    if (all.includes("new")) {
      return `<div class="card-product-slim__badge card-product-slim__newHighlight">New in</div>`;
    } else {
      return ``;
    }
  };

  const isSale = () => {
    let all = data.collections.toString();
    if (all.includes("sale")) {
      return `<div class="card-product-slim__badge card-product-slim__saleHighlight">Sale</div>`;
    } else {
      return ``;
    }
  };

  const hasFlavour = () => {
    // console.log(data);
    if (data.named_tags.Profile) {
      if (typeof data.named_tags.Profile == "string") {
        return data.named_tags.Profile;
      }
    } else {
      return "";
    }
  };

  const isDisposable = () => {
    let all = data.collections.toString();
    if (all.includes("disposable-vape-kits")) {
      return true;
    } else {
      return false;
    }
  };

  const disposableCount = () => {
    let all = data.tags;
    let c = "";
    all.filter((t, i) => {
      if (t.includes("Profile_")) {
        c = t.replace("Profile_", "");
        return t.replace("Profile_", "");
      } else {
        return "";
      }
    });
    return c;
  };

  // const isOutOfStockHelper = () => {

  //   let totalCounter = 0;
  //   const allLocations = data.locations_inventory;

  //   Object.keys(allLocations).forEach((key) => {
  //     if(key == "12632293494"){
  //       totalCounter = 0;
  //     } else {
  //       totalCounter = totalCounter + allLocations[key];
  //     }
  //   });

  //   if (data.variants_inventory_count <= 0) {
  //     return `<div class="card-product-slim__oos">Out Of Stock</div>`;
  //   } else if(totalCounter == 0 && !isDisposable()) {
  //     return `<div class="card-product-slim__oos">Out Of Stock</div>`;
  //   } else {
  //     return "";
  //   }
  // };

  const isOutOfStockHelper = () => {
    if (data.variants_inventory_count == 0) {
      return true;
    } else {
      return "";
    }
  };

  // const isOutOfStock = () => {
  //   let totalCounter = 0;
  //   const allLocations = data.locations_inventory;

  //   Object.keys(allLocations).forEach((key) => {
  //     if(key == "12632293494"){
  //       totalCounter = 0;
  //     } else {
  //       totalCounter = totalCounter + allLocations[key];
  //     }
  //   });


  //   if (data.variants_inventory_count <= 0) {
  //     return `<div class="card-product-slim__oos">Out Of Stock</div>`;
  //   } else if(totalCounter == 0 && !isDisposable()) {
  //     return `<div class="card-product-slim__oos">Out Of Stock</div>`;
  //   } else {
  //     return "";
  //   }
  // };

  const isOutOfStock = () => {
    if (data.variants_inventory_count <= 0) {
      return `<div class="card-product-slim__oos">Out Of Stock</div>`;
    } else {
      return "";
    }
  };

  const getMultibuyOffer = () => {
    let tags = data.tags.toString();
    let _items = window?.multibuyOffer?.tags;

    if (isOutOfStockHelper()) {
      return "";
    } else {
      if (data.collections) {
        let found = false;
        let content;

        for (let i = 0; i < _items.length; i++) {
          if (tags.includes(_items[i].tag)) {
            found = true;
            content = _items[i].return;
            break;
          }
        }

        if (found) {
          return content;
        } else {
          return ``;
        }
      }
    }
  };


  const getRelevantBadge = () => {
    let tags = data.tags.toString();
    let _items = window?.relevantBadges?.tags;


    if (isOutOfStockHelper()) {
      return "";
    } else {
      if (data.collections) {
        let found = false;
        let content;

        for (let i = 0; i < _items.length; i++) {
          if (tags.includes(_items[i].tag)) {
            found = true;
            content = _items[i].return;
            break;
          }
        }

        if (found) {
          return content;
        } else {
          return ``;
        }
      }
    }

  };

  const isOnSale = () => {
    if (!data.compare_at_price) {
      return false;
    } else {
      return true;
    }
  };

  const areAllVariantsDiscounted = () => {
    if (data.compare_at_price != 0 && data.variants_min_price == data.variants_max_price) {
      return true;
    } else {
      return false;
    }
  };

  const determinePrice = () => {
    let originalPrice;
    if (!data.compare_at_price) {
      originalPrice = data.price;
    } else {
      originalPrice = data.compare_at_price;
    }

    if (data.price == 0) {
      return "TBC";
    }

    if (isOnSale()) {
      if(areAllVariantsDiscounted()) {
        return `<span class="pre-sale-price"> Was £${originalPrice}</span> <span class="sale-price">Now £${data.variants_min_price.toFixed(2)}</span>`
      } else {
        return data.variants_count > 1
        ? `From £${data.variants_min_price.toFixed(2)}`
        : `£${data.price}`
      }
    } else {
      return data.variants_count > 1 && data.variants_min_price != data.variants_max_price
        ? `From £${data.variants_min_price}`
        : `£${data.price}`;
    }
  };

  const sendEv = () => {
    sendEvent("click", data, "Search: clicked v2");
  };

  // render

  if (data.isPromo) {
    return `
          <div class="card-product card-carousel-js swiper-slide" data-handle="${data.handle}">
          <a class="card-product__wrapper-link" href="/products/${data.handle}"></a>
            <div class="card-product__imagewrap">

            </div>
            <div class="card-product__wrapper">
              <h4 class="card-product__heading">PROMO CARD</h4>
            </div>
          </div>
        `;
  } else {

    return `
          <div data-pos="${data.__position}" data-objectID="${
            data.objectID
          }" id="Swiper-search-card-${
            data.id
          }" class="card-product-slim card-carousel-js swiper-slide search-res-card" data-handle="${
            data.handle
          }"
          onClick="(function(){
            localStorage.setItem('clickedObjectID', ${data.objectID});
        })();"
          >
          <a class="card-product-slim__wrapper-link" href="/products/${
            data.handle
          }"></a>
            <div class="card-product-slim__imagewrap">
              <img class="card-product-slim__thumb ${
                isOutOfStockHelper() ? "greyed" : ""
              }" src="${data.product_image}&width=300" alt="${
                data.title
              }" width="230" height="auto" alt="" loading="lazy" />
            </div>
              ${getRelevantBadge()}
              ${isNew()}
              ${isSale()}
              ${getMultibuyOffer()}
            <div class="card-product-slim__wrapper">
              <h4 class="card-product-slim__heading">${data.title}</h4>
              ${
                isDisposable()
                  ? `<div class="card-product-slim__flavour">${disposableCount()}</div>`
                  : `<div class="card-product-slim__flavour">${hasFlavour()}</div>`
              }
              <div class="card-product-slim__price ${
                isOutOfStockHelper() ? "greyed" : ""
              }">
                ${determinePrice() == '£null' ? `£${data.price}` : determinePrice()}
              </div>
            </div>
          </div>
        `;
  }
};

const renderSortBy = (renderOptions, isFirstRender) => {
  const {options, currentRefinement, hasNoResults, refine, widgetParams} =
    renderOptions;

  if (isFirstRender) {
    const select = document.createElement("div");
    // select.setAttribute("size", 10);
    select.setAttribute("class", "select-sortby");

    select.addEventListener("click", (event) => {
      refine(event.target.id);
    });

    widgetParams.container.appendChild(select);
  }

  const select = widgetParams.container.querySelector("div");

  select.disabled = hasNoResults;

  select.innerHTML = `
      ${options
        .map(
          (option) => `
            <span
              class="sort-option"
              id="${option.value}"
              ${option.value === currentRefinement ? "selected" : ""}
            >
              ${option.label}
            </span>
          `,
        )
        .join("")}
    `;
};

// Create the custom widget
const customSortBy = connectSortBy(renderSortBy);

const renderMobileSortBy = (renderOptions, isFirstRender) => {
  const {options, currentRefinement, hasNoResults, refine, widgetParams} =
    renderOptions;

  if (isFirstRender) {
    const select = document.createElement("div");
    // select.setAttribute("size", 10);
    select.setAttribute("class", "select-sortby");

    select.addEventListener("click", (event) => {
      // console.log(event);
      refine(event.target.id);
    });

    widgetParams.container.appendChild(select);
  }

  const select = widgetParams.container.querySelector("div");

  select.disabled = hasNoResults;

  select.innerHTML = `
      ${options
        .map(
          (option) => `
            <span
              class="sort-option"
              id="${option.value}"
              ${option.value === currentRefinement ? "selected" : ""}
            >
              ${option.label}
            </span>
          `,
        )
        .join("")}
    `;
};

// Create the custom widget
const customMobileSortBy = connectSortBy(renderMobileSortBy);


function addStockState(card, data) {
  const insertion = card.querySelector(".card-product__imagewrap");
  const hasOOS = card.querySelector(".card-product__oos");

  if (!hasOOS) {
    const _oos = data;
    insertion.insertAdjacentHTML("afterend", _oos);

    if (
      card.querySelector(".card-product__oos").innerHTML.length != 0 ||
      null
    ) {
      card.querySelector(".card-product__thumb ").classList.add("greyed");
    }
  }
}

function addVariantColors(card, data) {
  const wrapper = card.querySelector(".card-product__wrapper");
  const hasColour = wrapper.querySelector(".card-product__colours img");

  // wrapper.innerHTML += data;

  // return options only once
  if (!hasColour) {
    wrapper.innerHTML += data;
  }
}

// ========================================================================================================================
// **********************
// SEARCH SUGGESTIONS  **
// **********************
// ========================================================================================================================

// build URLs that InstantSearch understands.
function getInstantSearchUrl(indexUiState) {
  return search.createURL({[INSTANT_SEARCH_INDEX_NAME]: indexUiState});
}

// detect when an event is modified with a special key to let the browser
// trigger its default behavior.
function isModifierEvent(event) {
  const isMiddleClick = event.button === 1;

  return (
    isMiddleClick ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey
  );
}

function onSelect({setIsOpen, setQuery, event, query}) {
  // you want to trigger the default browser behavior if the event is modified.
  if (isModifierEvent(event)) {
    return;
  }
  setQuery(query);
  setIsOpen(false);
  setInstantSearchUiState({query});
}

function getItemUrl({query}) {
  return getInstantSearchUrl({query});
}

function createItemWrapperTemplate({children, query, html}) {
  const uiState = {query};

  return html`<a
    class="aa-ItemLink"
    href="${getInstantSearchUrl(uiState)}"
    onClick="${(event) => {
      if (!isModifierEvent(event)) {
        // Bypass the original link behavior if there's no event modifier
        // to set the InstantSearch UI state without reloading the page.
        event.preventDefault();
      }
    }}"
  >
    ${children}
  </a>`;
}

// set the InstantSearch index UI state from external events.
function setInstantSearchUiState(indexUiState) {
  // console.log(indexUiState);
  search.setUiState((uiState) => ({
    ...uiState,
    [INSTANT_SEARCH_INDEX_NAME]: {
      ...uiState[INSTANT_SEARCH_INDEX_NAME],
      // reset the page when the search state changes.
      page: 1,
      ...indexUiState,
    },
  }));
  if (indexUiState.query == "") {
    document
      .querySelector("#searchHitsContainer")
      .classList.add("visually-hidden");
  } else {
    document
      .querySelector("#searchHitsContainer")
      .classList.remove("visually-hidden");
  }
}

// return the InstantSearch index UI state.
function getInstantSearchUiState() {
  const uiState = instantSearchRouter.read();

  return (uiState && uiState[INSTANT_SEARCH_INDEX_NAME]) || {};
}

const searchPageState = getInstantSearchUiState();

let skipInstantSearchUiStateUpdate = false;

function debounce(fn, time) {
  let timerId = undefined;

  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => fn(...args), time);
  };
}

const debouncedSetInstantSearchUiState = debounce(
  setInstantSearchUiState,
  2500,
);

// Mount a virtual search box to manipulate InstantSearch's `query` UI
// state parameter.
const virtualSearchBox = connectSearchBox(() => {});

// the users seacrh terms get reflected in the hits here

let objectArray = [];

// Create a render function
const renderVoiceSearch = (renderOptions, isFirstRender) => {
  const {isListening, toggleListening, voiceListeningState} = renderOptions;

  const container = document.querySelector("#voicesearch");

  if (isFirstRender) {
    const button = document.createElement("button");
    button.classList.add("ais-VoiceSearch-button");
    button.setAttribute("aria-label", "&nbsp;");
    button.innerText = "&nbsp;";
    button.addEventListener("click", (event) => {
      toggleListening();
      setTimeout(() => {
        toggleListening();
      }, 10000);
    });
    container.appendChild(button);

    const state = document.createElement("pre");
    container.appendChild(state);
  }

  if (isListening) {
    document.querySelector("#voice-prompt").classList.remove("visually-hidden");
  } else {
    document.querySelector("#voice-prompt").classList.add("visually-hidden");
  }

  container.querySelector("button").innerHTML = isListening
    ? "Stop"
    : '<span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" fill="none"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line></svg></span>';
};

// create custom widget
const customVoiceSearch = connectVoiceSearch(renderVoiceSearch);

// if theres a no results, show the suggested items and vice verca
search.addWidgets([
  virtualSearchBox({}),
  infiniteHits({
    container: "#searchHits",
    templates: {
      empty(results, {html}) {
        if (window.innerWidth < 1024) {
          document.querySelector(
            ".mobile-refinement-options.inner-search",
          ).style.display = "none";
        } else {
          document.querySelector("#refine.refine-inner-search").style.display =
            "none";
        }
        // document.querySelector("#pagination-searchbar").style.display = "none";
        document.querySelector("#searchHits-no-res").style.display = "block";

        return html`<div>
          <div class="no-res">
            We are sorry there are no results for your search
            <span>"${results.query}"</span>
          </div>
          <div></div>
        </div>`;
      },
      item: (data, {html, sendEvent}) => {
        objectArray.push(data.objectID);
        localStorage.setItem("queryID", data.__queryID);
        localStorage.setItem("objectIDS", objectArray);
        if (window.innerWidth < 1024) {
          document.querySelector(
            ".mobile-refinement-options.inner-search",
          ).style.display = "flex";
        } else {
          document.querySelector("#refine.refine-inner-search").style.display =
            "flex";
        }

        // document.querySelector("#pagination-searchbar").style.display = "flex";
        document.querySelector("#searchHits-no-res").style.display = "none";

        return determineProductCard(data, sendEvent);
      },
    },
    cssClasses: {
      root: "hits-results-list",
      list: "results-grid inside-search",
    },
  }),
  currentRefinements({
    container: "#current-filters-inner-search",
    transformItems(items) {
      items.map((i) => {
        switch (i.label) {
          case "named_tags.Type":
            i.label = "Type";
            break;
          case "named_tags.FlavourGroup":
            i.label = "Flavour Group";
            break;
          case "named_tags.Flavour":
            i.label = "Flavour";
            break;
          case "vendor":
            i.label = "Brand";
            break;
          case "named_tags.Size":
            i.label = "Size";
            break;
          case "named_tags.Strength":
            i.label = "Strength";
            break;
          case "named_tags.Ratio":
            i.label = "PG/VG Ratio";
            break;
          case "named_tags.Wattage":
            i.label = "Wattage";
            break;
          case "named_tags.Battery":
            i.label = "Battery";
            break;
          case "named_tags.Resistance":
            i.label = "Resistance";
            break;
          case "named_tags.Offer":
            i.label = "Offers";
            break;
          case "price":
            i.label = "Price";
            break;
          default:
            break;
        }
      });
      return items;
    },
  }),
  clearRefinements({
    container: "#clear-filters-inner-search",
    templates: {
      resetLabel: "Clear All",
    },
  }),
  refinementList({
    container: "#refine-type-inner-search",
    attribute: "named_tags.Type",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),
  refinementList({
    container: "#refine-flavourGroup-inner-search",
    attribute: "named_tags.FlavourGroup",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),
  refinementList({
    container: "#refine-flavour-inner-search",
    attribute: "named_tags.Flavour",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
    transformItems(items) {
      if (items.length > 10) {
        document
          .querySelector("#refine-flavour-inner-search")
          .classList.add("opened");
      } else {
        document
          .querySelector("#refine-flavour-inner-search")
          .classList.remove("opened");
      }
      return items;
    },
    cssClasses: {
      root: "flavour-list",
    },
  }),
  refinementList({
    container: "#refine-brand-inner-search",
    attribute: "vendor",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
    transformItems(items) {
      if (items.length > 10) {
        document
          .querySelector("#refine-brand-inner-search")
          .classList.add("opened");
      } else {
        document
          .querySelector("#refine-brand-inner-search")
          .classList.remove("opened");
      }
      return items;
    },
  }),
  refinementList({
    container: "#refine-size-inner-search",
    attribute: "named_tags.Size",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  refinementList({
    container: "#refine-nic-inner-search",
    attribute: "named_tags.Strength",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  refinementList({
    container: "#refine-ratio-inner-search",
    attribute: "named_tags.Ratio",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  refinementList({
    container: "#refine-wattage-inner-search",
    attribute: "named_tags.Wattage",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  refinementList({
    container: "#refine-battery-inner-search",
    attribute: "named_tags.Battery",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  refinementList({
    container: "#refine-resistance-inner-search",
    attribute: "named_tags.Resistance",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  refinementList({
    container: "#refine-offers-inner-search",
    attribute: "named_tags.Offer",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),
  customSortBy({
    container: document.querySelector("#sort-by-inner-search"),
    items: [
      {label: "Featured", value: "shopify_products"},
      {
        label: "Best Selling",
        value: "shopify_products_recently_ordered_count_desc",
      },
      {label: "Price ascending", value: "shopify_products_price_asc"},
      {label: "Price descending", value: "shopify_products_price_desc"},
      {label: "Title ascending", value: "shopify_products_title_asc"},
      {label: "Title descending", value: "shopify_products_title_desc"},
      {label: "Created ascending", value: "shopify_products_published_at_asc"},
      {
        label: "Created descending",
        value: "shopify_products_published_at_desc",
      },
    ],
  }),



  // add seperate mobile refinements

  clearRefinements({
    container: "#mobile-clear-inner-search",
    templates: {
      resetLabel: "Clear",
    },
  }),

  refinementList({
    container: "#mobile-refine-type-inner-search",
    attribute: "named_tags.Type",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),

  refinementList({
    container: "#mobile-refine-flavourGroup-inner-search",
    attribute: "named_tags.FlavourGroup",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      root: "group-list",
    },
  }),

  refinementList({
    container: "#mobile-refine-flavour-inner-search",
    attribute: "named_tags.Flavour",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
    cssClasses: {
      root: "flavour-list",
    },
  }),

  refinementList({
    container: "#mobile-refine-brand-inner-search",
    attribute: "vendor",
    limit: 10,
    showMore: true,
    showMoreLimit: 100,
  }),

  refinementList({
    container: "#mobile-refine-size-inner-search",
    attribute: "named_tags.Size",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-nic-inner-search",
    attribute: "named_tags.Strength",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-ratio-inner-search",
    attribute: "named_tags.Ratio",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-wattage-inner-search",
    attribute: "named_tags.Wattage",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-battery-inner-search",
    attribute: "named_tags.Battery",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-resistance-inner-search",
    attribute: "named_tags.Resistance",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  refinementList({
    container: "#mobile-refine-offers-inner-search",
    attribute: "named_tags.Offer",
    limit: 10,
    showMore: true,
    showMoreLimit: 40,
  }),

  customMobileSortBy({
    container: document.querySelector("#mobile-sort-by-inner-search"),
    items: [
      {label: "Featured", value: "shopify_products"},
      {
        label: "Best Selling",
        value: "shopify_products_recently_ordered_count_desc",
      },
      {label: "Price ascending", value: "shopify_products_price_asc"},
      {label: "Price descending", value: "shopify_products_price_desc"},
      {label: "Title ascending", value: "shopify_products_title_asc"},
      {label: "Title descending", value: "shopify_products_title_desc"},
      {label: "Created ascending", value: "shopify_products_published_at_asc"},
      {
        label: "Created descending",
        value: "shopify_products_published_at_desc",
      },
    ],
  }),
  customVoiceSearch({
    container: document.querySelector("#voicesearch"),
    language: "en-UK",
    searchAsYouSpeak: true,
    additionalQueryParameters(q) {
      let _q = `/search${q.query}`;
      setInstantSearchUiState({query: _q});
      setQuery(`${q.query}`);
      document
        .querySelector("#search-res-wrapper")
        .classList.remove("visually-hidden");
      return {
        ignorePlurals: false,
      };
    },
  }),
]);

//  remove / block any empty facets from filters
search.on("render", () => {
  document.querySelectorAll(".ais-RefinementList").forEach((f) => {
    let facetCount = f.querySelector(".ais-RefinementList-list");

    if (
      f.childElementCount == 0 ||
      (facetCount != null && facetCount.childElementCount == 1)
    ) {
      let parent = f.parentNode.previousElementSibling;
      parent.classList.add("blocked");
      parent.parentNode.classList.add("blocked");
    } else {
      let parent = f.parentNode.previousElementSibling;
      parent.classList.remove("blocked");
      parent.parentNode.classList.remove("blocked");
    }
  });

  const cards = document.querySelectorAll(".search-res-card");

  cards.forEach((item) => {
    const handle = item.dataset.handle;
    getReviewInfo(item, handle);
  });

  //tester
  // console.log(cards.length)
  // cards.forEach((item) => {
  //   const handle = item.dataset.handle;
  //   getShopifyProduct(item, handle);
  // });

  // console.log(cards);
});

// run the init on searches
search.start();
// searchCols.start();

// ========================================================================================================================
// ***************************
// SEARCH AUTOCOMPLETE HITS **
// ***************************
// ========================================================================================================================

const {setQuery} = autocomplete({
  container: "#autocomplete",
  placeholder: "Search products, brands or category",
  detachedMediaQuery: "none",
  insights: false,
  initialState: {
    query: searchPageState.query || "",
  },
  onSubmit({state}) {
    setInstantSearchUiState({query: state.query});
  },
  onReset() {
    setInstantSearchUiState({query: ""});
    document
      .querySelector("#searchHitsContainer")
      .classList.add("visually-hidden");

    document.querySelector("#searchHitsContainer").classList.add("closed");
  },
  onFocus() {
    document
      .querySelector("#search-res-wrapper")
      .classList.remove("visually-hidden");
  },
  onStateChange({prevState, state}) {
    if (document.querySelector(".aa-ClearButton")) {
      document.querySelector(".aa-ClearButton").innerHTML = "reset";
    }

    document.querySelector("#searchHitsContainer").style.overflow = "auto";

    if (state?.query == "") {
      document
        .querySelector("#searchHitsContainer")
        .classList.add("visually-hidden");

      document.querySelector("#searchHitsContainer").classList.add("closed");
    } else {
      document
        .querySelector("#search-res-wrapper")
        .classList.remove("visually-hidden");

      document.querySelector("#searchHitsContainer").classList.remove("closed");
    }
    if (!skipInstantSearchUiStateUpdate && prevState.query !== state.query) {
      debouncedSetInstantSearchUiState({query: state.query});
      setInstantSearchUiState({query: state.query});
    }
    skipInstantSearchUiStateUpdate = false;
  },
  // plugins: [algoliaInsightsPlugin],
});

// This keeps Autocomplete aware of state changes coming from routing
// and updates its query accordingly
window.addEventListener("popstate", () => {
  skipInstantSearchUiStateUpdate = true;
  setQuery(search.helper?.state.query || "");
});

// ========================================================================================================================
// **********************
// NON ALGOLIA EVENTS  **
// **********************
// ========================================================================================================================

document.addEventListener("DOMContentLoaded", () => {
  // re-direct the users back to search page when they go back in the browser after clicking on a product
  if (
    window.performance &&
    window.performance.navigation.type ==
      window.performance.navigation.TYPE_BACK_FORWARD
  ) {
    const currentURL = new URL(window.location.href);
    const searchQuery = currentURL.searchParams.get("q");
    // console.log(document.referrer);

    if (searchQuery) {
      setQuery(searchQuery);
      document.querySelector("#autocomplete-0-input").value = searchQuery;
      // window.location.href = '/search?q=' + searchQuery;
    }
  }

  // when user clicks into search bar, open the menu by default
  document
    .querySelector("#autocomplete-0-input")
    .addEventListener("focus", () => {
      document
        .querySelector("#search-res-wrapper")
        .classList.remove("visually-hidden");
      document
        .querySelector("#searchHitsContainer")
        .classList.add("visually-hidden");

      document.querySelector("#searchHitsContainer").classList.add("closed");

      document.querySelector("body").classList.add("stop-scrolling");
    });

  // when users mouse leaves active area, close all open menus
  // also unfoucs the input

  // when user clicks the x on the right of the top search bar, close all the tings
  document.querySelector("#clear-all").addEventListener("click", () => {
    document.querySelector("#h-wrapper-top").style.paddingTop = document
      .querySelector("#clear-all")
      .getAttribute("data-padding");

    setInstantSearchUiState({query: ""});

    document.querySelector(".aa-Form").reset();

    document.querySelector("body").classList.remove("stop-scrolling");

    document.querySelector("#autocomplete-0-input").blur();
    document
      .querySelector("#search-res-wrapper")
      .classList.add("visually-hidden");
    document
      .querySelector("#searchHitsContainer")
      .classList.add("visually-hidden");

    document.querySelector("#searchHitsContainer").classList.add("closed");

    window.scrollTo(0, 0);
  });
});

// get url for reviews
async function getReviewInfo(card, handle) {

  if (handle == undefined || null) {
  } else {
    const shopifyProductUrl = `/products/${handle}?section_id=product-extras-reviews`;

    try {
      const response = await fetch(shopifyProductUrl);
      const res = await response.text();

      let p = new DOMParser();
      let doc = p.parseFromString(res, "text/html");
      let template = doc.querySelector(".tp-stars-rating");

      const wrapper = card;

      wrapper.appendChild(template);

    } catch (error) {
      console.error("Error:", error);
    }

  }
}

async function getShopifyProduct(card, handle) {
  if (handle == undefined || null) {
    return;
  } else {
    const shopifyProductUrl = `/products/${handle}?section_id=product-extras`;

    try {
      const response = await fetch(shopifyProductUrl);
      const res = await response.text();

      let p = new DOMParser();
      let doc = p.parseFromString(res, "text/html");
      let template = doc.querySelector(".quick-view__container");
      let stocker = doc.querySelector(".card-product__oos");

      const insertion = card.querySelector(".card-product__imagewrap");

      const wrapper = card.querySelector(".card-product__wrapper");
      const hasColour = wrapper.querySelector(".card-product__colours img");

      if (!hasColour) {
        wrapper.appendChild(template);
      }

      if (stocker != null) {
        if (!card.querySelector(".card-product__oos")) {
          insertion.appendChild(stocker);
        }
        if (
          card.querySelector(".card-product__oos")?.innerHTML.length != 0 ||
          null
        ) {
          card.querySelector(".card-product__thumb ").classList.add("greyed");
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
}